<a [routerLink]="route" class="btn btn--section">
  <svg-icon
    [applyClass]="true"
    [src]="svgPath"
    class="icon s48"
  ></svg-icon>
  <h2>{{title}}</h2>
</a>
